var _path, _path2, _circle;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnQuestion = function SvgIcnBtnQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.4C5.36081 18.4 1.6 14.6392 1.6 10C1.6 5.36081 5.36081 1.6 10 1.6C14.6392 1.6 18.4 5.36081 18.4 10C18.4 14.6392 14.6392 18.4 10 18.4Z",
    stroke: "#A4A7AD",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.205 12.039H10.528C10.528 11.745 10.535 11.5047 10.549 11.318C10.563 11.1313 10.633 10.9283 10.759 10.709C10.899 10.4617 11.1067 10.24 11.382 10.044C11.662 9.84333 11.9187 9.617 12.152 9.365C12.4273 9.07567 12.649 8.75133 12.817 8.392C12.985 8.03267 13.069 7.64533 13.069 7.23C13.069 6.894 13.0153 6.572 12.908 6.264C12.8007 5.956 12.6373 5.68067 12.418 5.438C12.1333 5.10667 11.7763 4.86867 11.347 4.724C10.9223 4.57467 10.472 4.5 9.996 4.5C9.63667 4.5 9.27967 4.556 8.925 4.668C8.57033 4.77533 8.25533 4.94567 7.98 5.179C7.68133 5.417 7.45033 5.72033 7.287 6.089C7.12367 6.45767 7.028 6.84267 7 7.244H8.302C8.29733 7.02467 8.33 6.817 8.4 6.621C8.47 6.425 8.582 6.25933 8.736 6.124C8.88533 5.97467 9.072 5.865 9.296 5.795C9.52467 5.725 9.76733 5.69 10.024 5.69C10.2947 5.69 10.5537 5.732 10.801 5.816C11.053 5.89533 11.263 6.03767 11.431 6.243C11.641 6.48567 11.746 6.82167 11.746 7.251C11.746 7.49367 11.7133 7.72233 11.648 7.937C11.5873 8.147 11.466 8.35467 11.284 8.56C11.074 8.784 10.8617 8.97533 10.647 9.134C10.4323 9.288 10.2317 9.44667 10.045 9.61C9.85833 9.77333 9.69733 9.98567 9.562 10.247C9.41267 10.5177 9.31467 10.7977 9.268 11.087C9.226 11.3717 9.205 11.689 9.205 12.039Z",
    fill: "#A4A7AD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 14.2002,
    r: 1,
    fill: "#A4A7AD"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_question.792f8788.svg";
export { ForwardRef as ReactComponent };